export default __webpack_public_path__ + "static/media/step - 2.c85dfbc1.jpeg";